import { render, staticRenderFns } from "./SetupOverviewAlarm.vue?vue&type=template&id=e8a2fc48&scoped=true"
import script from "./SetupOverviewAlarm.vue?vue&type=script&lang=ts"
export * from "./SetupOverviewAlarm.vue?vue&type=script&lang=ts"
import style0 from "./SetupOverviewAlarm.vue?vue&type=style&index=0&id=e8a2fc48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a2fc48",
  null
  
)

export default component.exports